import produce from 'immer'
import { Reducer } from 'redux'

import { CMSCtx } from 'interfaces/cms'
import { SET_CMS_CTX } from 'redux/actions/types'

interface CMSState {
  ctx: CMSCtx | null
}

const initialState: CMSState = {
  ctx: null
}

const cms: Reducer<CMSState, any> = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_CMS_CTX:
      return produce(state, draft => {
        draft.ctx = action.ctx
      })
    default:
      return state
  }
}

export default cms
